import * as t from 'io-ts';

import {makeApiType} from './apiTypes';

// Errors are allowed to be dismissed for a maximum for 24 hours by the client.
const maxDismissalTime = 1000 * 60 * 60 * 24;

// Debug
// const maxDismissalTime = 30000;

export function isTimeAboveMaxDismissal(lastOccurredAt: number, dismissedTime: number) {
  return lastOccurredAt - dismissedTime > maxDismissalTime;
}

/*
 * Runtime type.
 */

const RIntegrationErrorDirty = t.readonly(
  t.type({
    id: t.Integer,
    integrationId: t.Integer,
    code: t.string,
    namespace: t.string,
    description: t.string,
    lastOccurredAt: t.Integer,
    ruleIds: t.readonlyArray(t.Integer),
  }),
  'integrationError',
);

/*
 * Type.
 */

export interface IntegrationErrorModel extends t.TypeOf<typeof RIntegrationErrorDirty> {}
export const RIntegrationError = t.clean<IntegrationErrorModel>(RIntegrationErrorDirty as any);
export const RIntegrationErrors = t.readonlyArray(RIntegrationError);

export function parseInitialIntegrationError(src: any): ReadonlyArray<IntegrationErrorModel> {
  return src && src.map(parseIntegrationErrors);
}

/*
 * IO methods.
 */

export function parseIntegrationErrors(src: any): IntegrationErrorModel {
  return {
    id: src.id,
    integrationId: src.integration_id,
    code: src.code,
    namespace: src.namespace,
    description: src.description,
    lastOccurredAt: src.last_occurred_at,
    ruleIds: src.rule_ids,
  };
}

/*
 * API type.
 */

export const ApiIntegrationError = makeApiType('integrationError', RIntegrationError, parseIntegrationErrors);
export const ApiIntegrationErrors = makeApiType(
  'integrationErrors',
  RIntegrationErrors,
  parseInitialIntegrationError,
);
